// TODO: Look for better alternative. The lint disable below is for the purpose of the TrainingContentPage wrappers in /retain and /training/extra.
// Optional alternative: custom wrapper component(s).
/* eslint-disable react/prop-types */
// Dependencies
import React from 'react';

import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import BackImage from 'components/BackImage';
import BookingTable from 'components/BookingTable';
import Header from 'components/Header';
import CheckLogin from 'components/LoginForm/CheckLogin';
import MessageCenter from 'components/MessageCenter';
import MobileWarning from 'components/MobileWarning';
import WebsiteSplitter from 'components/WebsiteSplitter';

import AdvisorView from 'views/AdvisorView';
import BadgeView from 'views/BadgeView';
import BookingFormView from 'views/BookingFormView';
import BookingRewardsView from 'views/BookingRewardsView';
import BookingsView from 'views/BookingsView';
import CollectionView from 'views/CollectionView';
import ContactView from 'views/ContactView';
import DashboardView from 'views/DashboardView';
import DirectoryView from 'views/DirectoryView';
// import ExhibitionView from 'views/ExhibitionView';
import FastFactsView from 'views/FastFactsView';
import FavoriteView from 'views/FavoriteView';
import HomeView from 'views/HomeView';
import IncentiveView from 'views/IncentiveView';
import LeaderboardView from 'views/LeaderboardView';
import NotFoundView from 'views/NotFoundView';
import NotLoggedInView from 'views/NotLoggedInView';
import RetainContentView from 'views/RetainContentView';
import RetainView from 'views/RetainView';
import RewardsView from 'views/RewardsView';
// import ShowcaseCollectionCountryView from 'views/ShowcaseCollectionCountryView';
import ShowcaseCollectionView from 'views/ShowcaseCollectionView';
import SubappsViewNew from 'views/SubAppViewNew';
import TermsAndConditionsView from 'views/TermsAndConditionsView';
import ThankYouView from 'views/ThankYouView';
// import SubAppView from 'views/SubAppView';
import ToolboxView from 'views/ToolboxView';
import TrainingContentView from 'views/TrainingContentView';
import TrainingExtraView from 'views/TrainingExtraView';
// import TrainingReportView from 'views/TrainingReportView';
import TrainingView from 'views/TrainingView';

const loginPages = ['training', 'retain', 'rewards'];
const paths = `(${loginPages.join('|')})`;

const SubRouter = () => (
  <div className="subRouter" id="container">
    <Route path={`/main/${paths}`} render={() => <CheckLogin />} />
    <Route
      path="/main/"
      render={(routerProps) => {
        const { pathname } = routerProps.location;
        if (pathname.includes('main/training/chapter/')) {
          return null;
        }
        if (pathname.includes('main/training/extra/chapter/')) {
          return null;
        }
        if (pathname.includes('main/fasttrack/chapter/')) {
          return null;
        }
        if (pathname.includes('main/directory')) {
          return null;
        }
        if (pathname.includes('main/sell/directory')) {
          return null;
        }
        return <Header pathname={pathname} />;
      }}
    />
    <div className="viewContainer">
      <BackImage />
      <Switch>
        <Route path="/main" exact component={HomeView} />
        <Route path="/main/landing" exact component={HomeView} />
        {/* <Route path="/main/hotel-showroom" exact component={ExhibitionView} />
        <Route path="/main/hotel-showroom/:category/:countryName" component={ShowcaseCollectionCountryView} />
        <Route path="/main/hotel-showroom/:category" component={ShowcaseCollectionView} /> */}
        <Route path="/main/sell/showcases" component={ShowcaseCollectionView} />
        <Route path="/main/promote/showcases" component={ShowcaseCollectionView} />

        <Route path="/main/mob" exact component={MobileWarning} />
        <Route path="/main/sell/contact" exact component={ContactView} />
        <Route path="/main/training" exact component={TrainingView} />
        <Route path="/main/training/extra/:id/" exact component={TrainingExtraView} />
        <Route path="/main/training/subapps/:id/" exact component={SubappsViewNew} />
        <Route path="/main/retain/subapps/:id/" exact component={SubappsViewNew} />
        {/* <Route path="/main/training/report-card" exact component={TrainingReportView} /> */}
        <Route path="/main/ret" exact component={RetainView} />
        <Route path="/main/ret/chapter" exact render={() => <Redirect to="/main/ret" />} />
        <Route path="/main/retain" exact component={RetainView} />
        <Route path="/main/retain/extra/:id/" exact component={TrainingExtraView} />
        {/* <Route path="/main/retain/chapter/:chapterId/:pageId" exact component={RetainContentView} /> */}
        <Route
          path="/main/:pageType/chapter/:chapterId/:pageId"
          render={(props) => {
            const { pageType, pageId } = props.match.params;
            switch (pageType) {
              case 'retain':
              case 'ret':
                return <RetainContentView key={pageId} {...props} />;
              case 'training':
              case 'fasttrack':
                return (
                  <TrainingContentView
                    key={pageId}
                    redirPath={`/main/${pageType}/chapter/`}
                    type={pageType}
                    {...props}
                  />
                );
              default:
                return null;
            }
          }}
        />
        <Route
          path="/main/:pageType/extra/chapter/:chapterId/:pageId"
          render={(props) => {
            const { pageType, pageId } = props.match.params;
            switch (pageType) {
              case 'retain':
              case 'ret':
                return <RetainContentView key={pageId} {...props} />;
              case 'training':
              case 'fasttrack':
                return (
                  <TrainingContentView
                    key={pageId}
                    redirPath={`/main/${pageType}/chapter/`}
                    type={pageType}
                    {...props}
                  />
                );
              default:
                return null;
            }
          }}
        />
        <Route path="/main/favorites" exact component={FavoriteView} />
        <Route path="/main/promote" exact component={FastFactsView} />
        <Route path="/main/sell" exact component={ToolboxView} />
        {/* <Route path="/main/subApp" exact component={SubAppView} /> */}
        <Route path="/main/directory" exact component={DirectoryView} />
        <Route path="/main/sell/directory" exact component={DirectoryView} />
        <Route path="/main/messages" exact component={MessageCenter} />
        <Route path="/main/rewards" exact component={RewardsView} />
        <Route path="/main/rewards/form" exact component={BookingFormView} />
        <Route path="/main/rewards/bookings" exact component={BookingsView} />
        <Route path="/main/rewards/messages" exact component={MessageCenter} />
        <Route path="/main/rewards/dashboard" exact component={DashboardView} />
        <Route path="/main/rewards/dashboard/training" exact component={TrainingView} />

        <Route
          path="/main/rewards/dashboard/training/chapter/:chapterId/:pageId"
          exact
          component={TrainingContentView}
        />
        <Route path="/main/rewards/terms" exact component={TermsAndConditionsView} />
        <Route path="/main/rewards/thank-you" exact component={ThankYouView} />
        <Route path="/main/rewards/achievements" exact component={BadgeView} />
        <Route path="/main/rewards/marketplace" exact component={BookingRewardsView} />
        <Route path="/main/rewards/bookings/:bookingId?" component={BookingTable} />
        <Route path="/main/rewards/leaderboard" exact component={LeaderboardView} />

        <Route path="/main/rewards/:id?" component={IncentiveView} />

        <Route path="/main/landing/messages" exact component={MessageCenter} />
        <Route path="/main/promote/videos/:videoId?" component={CollectionView} />
        <Route path="/main/promote/images/:imageId?" component={CollectionView} />
        <Route path="/main/sell/videoLibrary/:videoId?" component={CollectionView} />
        <Route path="/main/sell/imageLibrary/:imageId?" component={CollectionView} />
        <Route path="/main/sell/advisor" exact component={AdvisorView} />
        <Route path="/main/(sell|promote)/:category/:item?" component={CollectionView} />
        <Route path="/main/off" component={NotLoggedInView} />
        <Route path="/main/splitter/:itemId/:type" component={WebsiteSplitter} />
        <Route component={NotFoundView} />
      </Switch>
    </div>
    {/* <Footer /> */}
  </div>
);

export default withRouter(SubRouter);
